export function registerImageDirectives(Alpine) {
  Alpine.directive("newsimagehover", (el) => {
    if (!window.gsap) return;
    let overlay = null;
    if (el.parentElement) {
      overlay = Array.from(el.parentElement.children).find(
        (c) =>
          c !== el && c.classList && c.classList.contains("news-img-overlay"),
      );
    }
    if (!overlay) return;
    overlay.style.pointerEvents = "none";
    gsap.set(el, { scale: 1 });
    gsap.set(overlay, { opacity: 0 });
    el.addEventListener("mouseenter", () => {
      gsap.to(el, { scale: 1.05, duration: 1.5, ease: "power2.out" });
      gsap.to(overlay, { opacity: 0.2, duration: 0.5, ease: "power2.out" });
    });
    el.addEventListener("mouseleave", () => {
      gsap.to(el, { scale: 1, duration: 1.5, ease: "power2.out" });
      gsap.to(overlay, { opacity: 0, duration: 0.5, ease: "power2.out" });
    });
  });
  
  // Alpine directive for image reveal/zoom and text fade-up
  Alpine.directive("imgrevealzoomtext", (el) => {
    // Find image and text children
    const img = el.querySelector("img");
    const textEls = el.querySelectorAll(".imgreveal-text");
    if (!img) return;

    img.style.background = "none";
    img.style.transition = "transform 2.2s cubic-bezier(0.33,1,0.68,1), clip-path 2s cubic-bezier(0.33,1,0.68,1)";
    img.style.transform = "scale(1.5)";
    img.style.clipPath = "inset(0 100% 0 0)";

    // Hide text initially
    textEls.forEach((t, idx) => {
      t.style.opacity = 0;
      t.style.transform = "translateY(32px)";
      t.style.transition = `opacity 1s cubic-bezier(0.33,1,0.68,1) ${0.2 + idx * 0.1}s, transform 1s cubic-bezier(0.33,1,0.68,1) ${0.2 + idx * 0.1}s`;
    });

    let activated = false;
    const activate = () => {
      if (activated) return;
      activated = true;
      setTimeout(() => {
        img.style.clipPath = "inset(0 0 0 0)";
        img.style.transform = "scale(1)";
      }, 200);
      setTimeout(() => {
        img.style.transition = "none";
      }, 2500);
      setTimeout(() => {
        textEls.forEach((t) => {
          t.style.opacity = 1;
          t.style.transform = "translateY(0)";
        });
      }, 1200); // Increased delay for text after image
    };

    // IntersectionObserver to trigger when in viewport
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            activate();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.005 },
    );
    observer.observe(el);
  });
}
